import * as turf from '@turf/turf'
import {LayerTypes} from '@models/layer'
import VectorLineLayer from '@models/vector-line-layer'
import VectorCircleLayer from '@models/vector-circle-layer'
import VectorFillLayer from '@models/vector-fill-layer'
import VectorLayer from '@models/vector-layer'
import * as Color from './Color'
import VectorTextLayer from '../models/vector-text-layer'

const darkColors = [
  '#212121', '#DD2C00', '#FF3D00', '#D84315', '#BF360C', '#3E2723', '#4E342E', '#263238', '#37474F', '#455A64', '#FF6D00', '#FF9100',
  '#00C853', '#00E676', '#1B5E20', '#2E7D32', '#388E3C', '#33691E', '#558B2F', '#827717', '#9E9D24', '#0091EA', '#00B0FF', '#00B8D4',
  '#00E5FF', '#00BFA5', '#1DE9B6', '#004D40', '#00695C', '#00796B', '#006064', '#00838F', '#01579B', '#0277BD', '#6200EA', '#651FFF',
  '#304FFE', '#3D5AFE', '#2962FF', '#1A237E', '#283593', '#311B92', '#4527A0', '#0D47A1', '#2962FF', '#1565C0', '#1976D2', '#B71C1C',
  '#6c093f', '#6A1B9A', '#4A148C', '#6A1B9A', '#D32F2F', '#C2185B', '#7B1FA2', '#303F9F', '#512DA8', '#1976D2']
const textColors = ['Red', 'Orange', 'Yellow', 'Green', 'Blue', 'Purple', 'Brown', 'Pink', 'Black', 'Grey', 'Gold']

const VectorUtils = {
  coordinatesToBBox (coordinates) {
    let polygon = turf.polygon(coordinates)
    return turf.bbox(polygon)
  },
  geomToBBox (feature) {
    let b = []
    feature.features.forEach(el => {
      b.push(el.geometry)
    })
    let a = turf.geometryCollection(b)
    return turf.bbox(a)
  },
  randomColor () {
    // return darkColors[Math.floor(Math.random() * darkColors.length)]
    return Color.randomColorHex()
  },
  textColor (index) {
    if (index >= textColors.length) {
      index = textColors.length - 1
    }
    return textColors[index]
  },
  mapVectorLayer (layer) {
    switch (layer.type) {
      case LayerTypes.VECTOR_LINE:
        return new VectorLineLayer(layer, true)
      case LayerTypes.VECTOR_FILL:
        return new VectorFillLayer(layer, true)
      case LayerTypes.VECTOR_CIRCLE:
        return new VectorCircleLayer(layer, true)
      case LayerTypes.VECTOR_TEXT:
        return new VectorTextLayer(layer, true)
    }
    return new VectorLayer()
  }
}
export default VectorUtils



// WEBPACK FOOTER //
// ./src/utils/vectorUtils.js